/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_AscInputs */

const cs_order_asc = /** @type {(inputs: Order_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vzestupně`)
};

const en_order_asc = /** @type {(inputs: Order_AscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ascending`)
};

/**
* | output |
* | --- |
* | "Ascending" |
*
* @param {Order_AscInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const order_asc = /** @type {((inputs?: Order_AscInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_AscInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_order_asc(inputs)
	return cs_order_asc(inputs)
});